import { render, staticRenderFns } from "./Socio-edit.vue?vue&type=template&id=0578c79b&"
import script from "./Socio-edit.vue?vue&type=script&lang=js&"
export * from "./Socio-edit.vue?vue&type=script&lang=js&"
import style0 from "./Socio-edit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Socio-edit.vue"
export default component.exports